import React from 'react'
import type { THighlightedTextProps } from 'src/components/ui/HighlightedText/types'
import 'src/components/ui/HighlightedText/styles.scss'

export const HighlightedText: React.FC<THighlightedTextProps> = ({ children }) => {
  return <span className="highlightedText">{children}</span>
}
